export default {
	field: 'classification',
	name: 'Classification',
}
